import * as Redux from 'redux';

import * as Actions from './AssignToUserModalActions';
import { User } from '../../misc/api/apiTypes';

export interface AssignToUserState {
    isVisible: boolean;
    isFetching: boolean;
    analysisSetId: string;
    selectedUser: string;
    errorMessage: string;
    users: Array<User>;
}

export const initialAssignToUser: AssignToUserState = {
    isVisible: false,
    isFetching: false,
    analysisSetId: null,
    selectedUser: null,
    errorMessage: null,
    users: null,
}

export function assignToUserReducer(state: AssignToUserState = initialAssignToUser, action: Actions.Action): AssignToUserState {
    switch (action.type) {
        case Actions.ActionType.OpenAssignModal:
            return {
                ...state,
                isVisible: true,
                analysisSetId: action.analysisSetId
            };
        case Actions.ActionType.CloseAssignModal:
            return initialAssignToUser;
        case Actions.ActionType.SelectUsers:
            return {
                ...state,
                selectedUser: action.userId,
            }
        case Actions.ActionType.ErrorRetrievingUsers:
            return {
                ...state,
                errorMessage: action.errorMessage,
            }
        case Actions.ActionType.DisableActionButton:
            return {
                ...state,
                isFetching: true,
            }
        default:
            return state;
    }
}
